import type {
  GreetingCardDecorationTransform,
  GreetingCardRect,
  GreetingCardSafeZone,
} from './schemas'
import { getGreetingCardRotatedBounds, type LayoutRect } from './inside-text-box'

const RECT_EPSILON = 0.5
export const GREETING_CARD_RATIO_RECT_EPSILON = 0

type TemplateSize = {
  width: number
  height: number
}

export function greetingCardTextBlockingSafeZones(
  safeZones: GreetingCardSafeZone[] | null | undefined,
) {
  return safeZones ?? []
}

function rectRight(rect: LayoutRect) {
  return rect.x + rect.width
}

function rectBottom(rect: LayoutRect) {
  return rect.y + rect.height
}

export function greetingCardRectsOverlap(
  a: LayoutRect,
  b: LayoutRect,
  epsilon = RECT_EPSILON,
) {
  return !(
    rectRight(a) <= b.x + epsilon
    || rectRight(b) <= a.x + epsilon
    || rectBottom(a) <= b.y + epsilon
    || rectBottom(b) <= a.y + epsilon
  )
}

export function greetingCardRatioRectToTemplateRect(
  bounds: GreetingCardRect,
  template: TemplateSize,
): LayoutRect {
  return {
    x: bounds.x * template.width,
    y: bounds.y * template.height,
    width: bounds.width * template.width,
    height: bounds.height * template.height,
  }
}

export function greetingCardSafeZonesToTemplateRects(
  safeZones: GreetingCardSafeZone[] | null | undefined,
  template: TemplateSize,
): LayoutRect[] {
  return (safeZones ?? [])
    .map((zone) => greetingCardRatioRectToTemplateRect(zone.bounds, template))
    .filter((rect) => rect.width > RECT_EPSILON && rect.height > RECT_EPSILON)
}

export function greetingCardTransformOverlapsSafeZones(
  transform: GreetingCardDecorationTransform,
  safeZoneRects: LayoutRect[],
) {
  const bounds = getGreetingCardRotatedBounds(transform)
  return safeZoneRects.some((safeZone) => greetingCardRectsOverlap(bounds, safeZone))
}

export type { LayoutRect }
